function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_4",
    "data-name": "\\u5716\\u5C64 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M509,124.88H318.91a19.7,19.7,0,0,0-11.35-35.83H292.44a19.7,19.7,0,0,0-11.35,35.83H91a13,13,0,1,0,0,26h23.82L143.31,456.6c2.89,31,30.46,54.35,64.13,54.35H392.56c33.67,0,61.24-23.37,64.13-54.35l28.48-305.76H509a13,13,0,1,0,0-26ZM430.84,454.19c-1.61,17.27-18.43,30.8-38.28,30.8H207.44c-19.85,0-36.67-13.53-38.28-30.8L140.9,150.84H459.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.37,437.14a13,13,0,0,0,13-13v-217a13,13,0,1,0-26,0v217A13,13,0,0,0,237.37,437.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.63,437.14a13,13,0,0,0,13-13v-217a13,13,0,1,0-26,0v217A13,13,0,0,0,362.63,437.14Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.6e994b902f6a3f16eb7448cf344aa551.svg";
export { ForwardRef as ReactComponent };